/* eslint-disable */
window.addEventListener(
  'message',
  (event) => {
    if (event.origin !== 'https://ui.pcon-solutions.com') {
      return;
    }
    const eventdata = event.data;
    if (eventdata && eventdata.action && eventdata.action === 'contact-request') {
      console.log(window.contacturl);
      window.location = window.contacturl + '?pcon=' + encodeURIComponent(eventdata.data.reopenUrl);
      return;
      //console.log(eventdata);
      //console.log(eventdata.data.obxUrl);
      //console.log(eventdata.data.reopenUrl);
      /*
      let reopenUrl = eventdata.data.reopenUrl;
      let obxUrl = eventdata.data.obxUrl;

      let emailBody = 'Guten Tag,\n'
        + 'ich möchte gerne mehr Informationen zu folgender Konfiguration::\n\n'
        + `${reopenUrl}` + '\n\n'
        + `${obxUrl}` + '\n\n'
        + 'Bitte kontaktieren Sie mich. Meine Kontaktdaten erhalten Sie mit dieser E-Mail.\nMit freundlichen Grüßen';
      console.log(emailBody);
      emailBody = encodeURIComponent(emailBody);
      window.location.href = 'mailto:anfrage@wini.de?subject=Produktanfrage aus WINI Konfigurator&body=' + `${emailBody}`;
       */
    }
  },
  false,
);
